// Per-page SEO metadata (title tags + meta descriptions) for static routes.
// Titles kept ~50-60 chars, descriptions ~150-160 chars, with location +
// primary keyword + brand. Derived from Search Console / SEMrush keyword data
// targeting Odessa, Midland & the Permian Basin.
// Updated Dec 2025: Phase 1 SEO Audit - optimized titles with primary keyword
// front-loaded, stronger CTAs, and geo-modifiers for local pack ranking.

export const seoConfig = {
  home: {
    path: '/',
    title: 'Plumbers in Odessa TX | 24/7 Emergency Service | Basin Plumbing',
    description:
      'Top-rated plumbers in Odessa & Midland, TX. 24/7 emergency plumbing, water heater repair, drain cleaning & gas lines. Same-day service. Call (432) 552-8385 for a free estimate.',
    keywords:
      'plumbers odessa tx, plumber odessa tx, plumbing odessa tx, emergency plumber, plumbers in midland, 24/7 plumber near me, basin plumbing',
  },
  services: {
    path: '/services',
    title: 'Plumbing Services Odessa & Midland TX | Basin Plumbing',
    description:
      'Complete plumbing services in Odessa & Midland: water heaters, drain cleaning, gas lines, sewer repair & trenchless. Licensed, insured, 24/7 available. Free estimates: (432) 552-8385.',
    keywords:
      'plumbing services odessa tx, plumbing services near me, water heater installation, drain cleaning odessa, gas line repair, trenchless plumbing',
  },
  contact: {
    path: '/contact',
    title: 'Contact Us | Basin Plumbing Odessa & Midland TX',
    description:
      'Get a free plumbing quote in Odessa & Midland, TX. Fast response, transparent pricing. Call (432) 552-8385 or fill out our form for 24/7 emergency service.',
    keywords:
      'contact plumber odessa tx, plumber near me, schedule plumber midland, emergency plumber phone number, basin plumbing contact',
  },
  faqs: {
    path: '/faqs',
    title: 'Plumbing FAQs | Common Questions | Basin Plumbing Odessa TX',
    description:
      'Get answers to common plumbing questions: costs, emergencies, water heaters, gas leaks & trenchless repair. Serving Odessa & Midland. Call (432) 552-8385.',
    keywords:
      'plumbing faqs, water heater replacement cost, how much does a plumber cost, gas leak signs, trenchless plumbing questions',
  },
  gallery: {
    path: '/gallery',
    title: 'Our Work | Plumbing Projects Odessa & Midland TX | Basin Plumbing',
    description:
      'Browse real plumbing projects by Basin Plumbing in Odessa, Midland & the Permian Basin. See our quality workmanship. Call (432) 552-8385 for your project.',
    keywords:
      'plumbing project gallery odessa, plumber work photos midland, basin plumbing projects, permian basin plumbing',
  },
  careers: {
    path: '/careers',
    title: 'Plumber Jobs Odessa TX | Now Hiring | Basin Plumbing',
    description:
      'Join Basin Plumbing in Odessa, TX. Hiring licensed plumbers & apprentices. Competitive pay, benefits & growth opportunities. Apply today!',
    keywords:
      'plumbing jobs odessa tx, plumber careers midland, licensed plumber hiring, plumber apprentice odessa, basin plumbing careers',
  },
  blog: {
    path: '/blog',
    title: 'Plumbing Tips & Guides | Basin Plumbing Odessa & Midland TX',
    description:
      'Expert plumbing tips for West Texas homeowners: water heater costs, trenchless repair, drain maintenance & more. Trusted advice from Basin Plumbing.',
    keywords:
      'plumbing blog, water heater replacement cost, what is trenchless plumbing, tankless vs tank water heater, ac drain line cleaning',
  },
  midland: {
    path: '/plumbers-in-midland',
    title: 'Plumber Midland TX | 24/7 Emergency Service | Basin Plumbing',
    description:
      'Trusted plumber in Midland, TX. 24/7 emergency plumbing, water heaters, drain cleaning, gas lines & trenchless repair. Call Basin Plumbing: (432) 552-8385.',
    keywords:
      'plumbers in midland, plumber midland tx, emergency plumber midland, midland plumbing company, water heater repair midland',
  },
};

export default seoConfig;
